import {
    css, Theme,
} from '@emotion/react'

const styles = (theme: Theme) => {
    return {
        wrapper: css`
            height: 70px;
            background: ${theme.palette.primary[400]};
            display: flex;
            justify-content: space-between;
            box-sizing: border-box;
            align-items: center;
        `,
        menuContainer: css` 
          padding: 18px 26px 
        `,
        breadCrumbs: css` flex-grow: 1 `,
        breadCrumbsText: css`
            white-space: nowrap;
            overflow: hidden;
        `,
        logoContainer: css`
            display: flex;
            cursor: pointer;
        `,
        menu: css`
            background-image: linear-gradient(0deg, #61c6e9 26.92%, #ffffff 26.92%, #ffffff 50%, #61c6e9 50%, #61c6e9 76.92%, #ffffff 76.92%, #ffffff 100%);
            background-size: 26px 26px;
            width: 38px;
            height: 34px;
        `,
        titleHeader: css`
            padding: 10px 0 12px 0;
            text-align: left;
        `,
        logo: css`
            padding: 4px 16px 9px 18px;
            height: 57px;
            width: 56px;
        `,
        logout: css`
            display: flex;
            align-items: center;
            justify-content: center;
            border: none;
            background: transparent;
            padding: 18px 26px;
            cursor: pointer;
        `,
    }
}

export default styles
